export default __webpack_public_path__ + "static/media/IBimageKneestabilityatloadingresponse1.96ad958a.png";